module.exports = __webpack_public_path__ + "img/palette-2_fg_jp.06e3d01.jpg";